export const getAggregateView = state => state.static.aggregateView;
